export enum BookingDialogType {
  Tickets = 'tickets',
  Uploads = 'uploads',
}
